/**
 * Mediatabs component. It displays photospanel, stickerspanel, backgroundspanel, layoutspanel and texts panels.
 * @constructor editor.mediatabs.MediaTabs
 * @param {object} dom DOM
 */

fx.ns("desktop.print", class MediaTabs extends fx.Component{
    
	constructor(data)
	{
		super(data);
		this.assets = fx.get("assets");

		this.listenUpdates( data.photos );

		this.effect = "hslidein";
	}

	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		if (val != this._currentArea)
			this._currentArea = val;
	}

	create()
	{
		super.create();

		this.tabs = new fx.components.TabsHorizontal();

        this.layoutPanel = new desktop.common.panels.LayoutsPanel( this.data );
		this.stickerPanel = new desktop.common.panels.StickersPanel( this.data );
		this.backgroundPanel = new desktop.common.panels.BackgroundsPanel(  this.data );
		
		this.tabs.addTab(fx.text("Modèles"), this.assets.LayoutTab, this.layoutPanel);
		this.tabs.addTab(fx.text("Fonds"), this.assets.BackgroundTab, this.backgroundPanel);
		this.tabs.addTab(fx.text("Stickers"), this.assets.StickerTab, this.stickerPanel);

		this.addChild(this.tabs,  {width:"100%", height: "100%"});
	}

	onReady()
    {
		super.onReady();
	}

});
